import LeaderboardTable from '../components/LeaderboardTable';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import * as React from 'react';
import {useState} from 'react';
import {faker} from '@faker-js/faker';
import CommonAppbar from '../components/common/CommonAppbar';
import getWeek from 'date-fns/getWeek'
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import subMonths from 'date-fns/subMonths'
import format from 'date-fns/format'
import startOfWeek from 'date-fns/startOfWeek'
import endOfWeek from 'date-fns/endOfWeek'
import startOfMonth from 'date-fns/startOfMonth'
import endOfMonth from 'date-fns/endOfMonth'
import {Link} from '@mui/material';


function CustomTabPanel(props) {
  const {children, value, index, ...other} = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{p: 3}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const weeklyData = (isTop10 = true, selectedRowId) => {
  const data = Array.apply(null, Array(10)).map((x, index) => {
    return {
      rank: index + 1,
      name: faker.helpers.arrayElement([faker.person.fullName(), `@${faker.person.firstName()}`]),
      points: faker.number.int({min: 1000, max: 10000})
    }
  })
  if (!isTop10) {
    data.push({
      rank: selectedRowId,
      name: faker.person.fullName(),
      points: faker.number.int({min: 10, max: 100})
    })
  }

  return data
}

const getWeeks = () => {
  const currentWeek = getWeek(new Date())
  const weeksList = []
  const startWeek = currentWeek - 10

  for (let i = startWeek; i < currentWeek; i++) {
    weeksList.push(i + 1)
  }
  return weeksList
}

export default function LeaderboardView() {
  const [value, setValue] = useState(0);
  const [currentWeek, setCurrentWeek] = useState(getWeek(new Date()));
  const curMonth = format(new Date(), 'MMMM')
  const [currentMonth, setCurrentMonth] = useState(curMonth);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const DATE_FORMAT = 'dd/MM/yyyy'
  const DATE_FORMAT = 'MMM d'
  // const DATE_FORMAT = 'P'
  const weeksList = getWeeks()

  const renderWeekDropdown = () => {
    return <FormControl size="small">
      <InputLabel id="demo-simple-select-label">Week</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="week-select"
        value={currentWeek}
        label="Week"
        onChange={(ev) => setCurrentWeek(ev.target.value)}
      >
        {weeksList.map(weekL => {
          return <MenuItem value={weekL}>Week {weekL}</MenuItem>
        })}
      </Select>
    </FormControl>
  }

  const renderMonthsDropdown = () => {
    const lastMonth = format(subMonths(new Date(), 1), 'MMMM')
    const secondLastMonth = format(subMonths(new Date(), 2), 'MMMM')

    return <FormControl size="small">
      <InputLabel id="demo-simple-select-label">Month</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="week-select"
        value={currentMonth}
        label="Month"
        onChange={(ev) => setCurrentMonth(ev.target.value)}
      >
        <MenuItem value={curMonth}>{curMonth}</MenuItem>
        <MenuItem value={lastMonth}>{lastMonth}</MenuItem>
        <MenuItem value={secondLastMonth}>{secondLastMonth}</MenuItem>
      </Select>
    </FormControl>
  }

  const currentUserRank = faker.number.int({min: 100, max: 1000})

  return <>
    <CommonAppbar isMainPage={true} pageHeader={`Leaderboard`}/>
    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="fullWidth">
        <Tab label="Week" {...a11yProps(0)} />
        <Tab label="Month" {...a11yProps(1)} />
        <Tab label="All time" {...a11yProps(2)} />
      </Tabs>
    </Box>
    <CustomTabPanel value={value} index={0}>
      {renderWeekDropdown()}
      <Typography variant="span" align={'center'} sx={{pl: 2}}>
        {format(startOfWeek(new Date()), DATE_FORMAT)} - {' '}
        {format(endOfWeek(new Date()), DATE_FORMAT)}
      </Typography>

      <LeaderboardTable rows={weeklyData()} selectedRow={faker.number.int({min: 1, max: 10})}/>
    </CustomTabPanel>
    <CustomTabPanel value={value} index={1}>
      <Typography variant="span" align={'center'} sx={{pl: 2}}>
        {format(startOfMonth(new Date()), DATE_FORMAT)} -
        {format(endOfMonth(new Date()), DATE_FORMAT)}
      </Typography>

      {renderMonthsDropdown()}
      <LeaderboardTable rows={weeklyData(false, currentUserRank)} selectedRow={currentUserRank}/>
    </CustomTabPanel>
    <CustomTabPanel value={value} index={2}>
      <LeaderboardTable rows={weeklyData()} selectedRow={faker.number.int({min: 1, max: 10})}/>
    </CustomTabPanel>
    <Link target={'_blank'} href={'https://example.com/'}>Click here</Link> to view rewards for top creators.
  </>
}
